module.exports = __webpack_public_path__ + "img/cloudProcess.0cea7f1e.svg";